<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  data: function () {
    return {
    }
  }
}
</script>

<style>
body {
  background:none transparent;
}

#app {
  height: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: #4391ce;
  background-repeat:no-repeat;
  background: -webkit-linear-gradient(to top right, #4391ce, #5bc0de);
  background: -moz-linear-gradient(to top right, #4391ce, #5bc0de);
  background: -ms-linear-gradient(to top right, #4391ce, #5bc0de);
  background: -o-linear-gradient(to top right, #4391ce, #5bc0de);
  background: linear-gradient(to top right, #4391ce, #5bc0de);
}
</style>



// WEBPACK FOOTER //
// src/App.vue